/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useState } from 'react';
import { ICoordinates } from 'react-give-me-map';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';

export interface ICtxDebug {
    coordinates: ICoordinates;
    point: IXY;
    zoom: number;
    setCoordinates: (coordinates: ICoordinates) => void;
    setPoint: (point: IXY) => void;
    setZoom: (zoom: number) => void;
}

export const CtxDebug = createContext<ICtxDebug>(null);

export const DebugStateProvider = ({ children }: { children: React.ReactNode }) => {
    const [coordinates, setCoordinates] = useState<ICoordinates>(null);
    const [point, setPoint] = useState<IXY>(null);
    const [zoom, setZoom] = useState<number>(null);

    return (
        <CtxDebug.Provider
            value={{
                coordinates,
                setCoordinates,
                point,
                setPoint,
                zoom,
                setZoom
            }}
        >
            {children}
        </CtxDebug.Provider>
    );
};
